// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2Idsn","selects":"Documents_selects__dPejs"};